<template>
    <u-header-fixed class="header--lnb-all header--dark">
        <!-- S: Header -->
        <!-- <u-header-head-basic class="d-none d-xl-block">
            <template #left>
                <div class="red">left</div>
            </template>
            <template #center>
                <div class="red text-center">center</div>
            </template>
            <template #right>
                <user-items-primary />
            </template>
        </u-header-head-basic> -->
        <u-header-body-basic class="d-none d-xl-block">
            <template #left>
                <logo-primary>더포디엄830</logo-primary>
            </template>
            <template #right>
                <u-gnb-underline class="text-center" gnbName="gnb" lnbTag="u-lnb-all-opacity-black" />
            </template>
            <!-- <template #right>
                <v-row align="center" class="row--sm">
                    <v-col cols="auto">
                        <language-items-primary id="header-language-items-primary" />
                    </v-col>
                    <v-col cols="auto">
                        <btn-hamburger-primary class="btn-hamburger--pc" />
                    </v-col>
                </v-row>
            </template> -->
        </u-header-body-basic>
        <!-- <u-header-foot-basic>
            <template #left>
                <div class="red">left</div>
            </template>
            <template #center>
                <div class="red text-center">center</div>
            </template>
            <template #right>
                <div class="red">right</div>
            </template>
        </u-header-foot-basic> -->
        <!-- E: Header -->

        <!-- S: Sitemap -->
        <!-- <sitemap-primary /> -->
        <!-- E: Sitemap -->
    </u-header-fixed>
</template>

<script>
import LogoPrimary from "@/components/publish/parents/headers/logo-primary.vue";
import UserItemsPrimary from "@/components/publish/parents/headers/user-items-primary.vue";
import LanguageItemsPrimary from "@/components/publish/parents/headers/language-items-primary.vue";
import BtnHamburgerPrimary from "@/components/publish/parents/buttons/btn-hamburger-primary.vue";
import SitemapPrimary from "@/sets/parents/headers/sitemap-primary.vue";

import UHeaderBasic from "@/sets/styles/headers/u-header-basic.vue";
import UHeaderFixed from "@/sets/styles/headers/u-header-fixed.vue";
import UHeaderHeadBasic from "@/sets/styles/headers/u-header-head-basic.vue";
import UHeaderBodyBasic from "@/sets/styles/headers/u-header-body-basic.vue";
import UHeaderFootBasic from "@/sets/styles/headers/u-header-foot-basic.vue";

import Gnb from "@/components/publish/styles/headers/gnb.vue";
import UGnbBasic from "@/components/publish/styles/headers/u-gnb-basic.vue";
import UGnbFilled from "@/components/publish/styles/headers/u-gnb-filled.vue";
import UGnbTopline from "@/components/publish/styles/headers/u-gnb-topline.vue";
import UGnbUnderline from "@/components/publish/styles/headers/u-gnb-underline.vue";

export default {
    components: {
        LogoPrimary,
        UserItemsPrimary,
        LanguageItemsPrimary,
        BtnHamburgerPrimary,
        SitemapPrimary,

        UHeaderBasic,
        UHeaderFixed,
        UHeaderHeadBasic,
        UHeaderBodyBasic,
        UHeaderFootBasic,

        Gnb,
        UGnbBasic,
        UGnbFilled,
        UGnbTopline,
        UGnbUnderline,
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {
        logout() {
            if (confirm("로그아웃 하시겠습니까?")) {
                this.$store.dispatch("logout");
            }
        },
    },
    computed: {
        accessToken() {
            return this.$store.state.accessToken;
        },
    },
};
</script>

<style lang="scss" scoped>
.header::v-deep {
    .header__bg {
        min-height: 0;
    }
}
.header.gnb-active::v-deep {
    .header__bg {
        min-height: var(--header-bg-height);
    }
}
</style>
